/**
 * background video 모듈
 * 브라우저 높이 계산, video play 기능
 */
// eslint-disable-next-line import/prefer-default-export
export const bgVideoMixin = {
  data() {
    return {
      mainVideo: null,
      paused: false,
    };
  },
  created() {
    // calc video height
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  methods: {
    updatePaused(event) {
      this.mainVideo = event.target;
      this.paused = event.target.paused;
    },
    pause() {
      this.mainVideo.pause();
    },
    play() {
      this.mainVideo.play();
    },
  },
};
